import React from 'react';
import { NewOrderDataEntryForm } from './NewOrderDataEntryForm';
import { SetupDataWrapper } from './wrappers/SetupDataWrapper';
import { useListProgramTypesQuery } from 'API/mobilityGroups/MobilityGroupApi';
import { useMyClientId } from 'components/accessControl/hooks/hooks';
import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';

export const CreateOrderContainer = () => {
  const userType = useGetUserType();

  const clientId = useMyClientId();

  const { data: programTypes = [] } = useListProgramTypesQuery(undefined, { skip: !!clientId });

  return (
    <SetupDataWrapper clientOrLenderId={clientId}>
      <NewOrderDataEntryForm userType={userType} clientId={clientId} programTypes={programTypes} />
    </SetupDataWrapper>
  );
};
